export default __webpack_public_path__ + "static/media/spinning-wheel.a1e5be74.wav";